import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const AtIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    {...props}
  >
    <Path d="M13.1143 9C13.1143 11.2723 11.2723 13.1143 9 13.1143C6.72774 13.1143 4.88571 11.2723 4.88571 9C4.88571 6.72774 6.72774 4.88571 9 4.88571C11.2723 4.88571 13.1143 6.72774 13.1143 9ZM13.1143 9V11.0571C13.1143 12.1933 14.0353 13.1143 15.1714 13.1143C16.3076 13.1143 17.2286 12.1933 17.2286 11.0571V9C17.2286 4.45549 13.5445 0.771429 9 0.771429C4.45549 0.771429 0.771429 4.45549 0.771429 9C0.771429 13.5445 4.45549 17.2286 9 17.2286" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

AtIcon.displayName = 'AtIcon';
